import { CSRF_COOKIE_NAME } from "@ids/shared";
import { IDS_EXCEPTION, type IIdsExceptionResponse } from "../../../src/shared";
import { logger } from "./logger";

const getCookieValue = (name: string): string | null => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop()?.split(";").shift() || null;
    }
    return null;
};

const isMutatingMethod = (method?: string) => {
    const m = (method ?? "GET").toUpperCase();
    return m === "POST" || m === "PUT" || m === "PATCH" || m === "DELETE";
};

export const fetchWithError = async <T = any>(
    url: string | URL,
    options?: RequestInit
): Promise<T> => {
    try {
        const method = options?.method;
        const headers = new Headers(options?.headers ?? {});
        if (isMutatingMethod(method)) {
            const csrf = getCookieValue(CSRF_COOKIE_NAME);
            if (csrf && !headers.has("X-CSRF-Token")) {
                headers.set("X-CSRF-Token", csrf);
            }
        }
        const response = await fetch(url, { ...(options ?? {}), headers });
        const data = await response.json();

        if (!response.ok) {
            if (data.error === IDS_EXCEPTION) {
                const err = data as IIdsExceptionResponse;
                throw new Error(err.alert["de"]);
            }
            const message = data?.message;
            if (message !== undefined && message !== null) {
                const text = Array.isArray(message)
                    ? message.join(", ")
                    : String(message);
                if (text) throw new Error(text);
            }
            throw new Error(
                "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie den Vorgang erneut."
            );
        }

        if (data.error) {
            throw new Error(
                data.message ||
                    "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie den Vorgang erneut."
            );
        }

        return data;
    } catch (error) {
        logger.error(
            `Request error: ${
                error instanceof Error ? error.message : String(error)
            }`,
            "fetchWithError"
        );
        throw error;
    }
};
